import Button from "Components/Common/Button/Button";
import { DocStatus } from "../types/precon.types";

const STATUS_LABELS: Record<DocStatus, string> = {
  done: "✓ Received",
  pending: "⏳ Pending",
  na: "N/A",
};

interface StatusButtonProps {
  status: DocStatus;
  onChange: () => void;
}

const StatusButton = ({ status, onChange }: StatusButtonProps) => {
  return (
    <Button className={`statusBtn ${status}`} onClick={onChange}>
      {STATUS_LABELS[status]}
    </Button>
  );
};

export default StatusButton;
